export const APK_VERSION_NAME_MAP: Record<string, string> = {
    '200': '2.0',
    '2.0': '2.0',
    '2.0.1': '2.0.1',
    '201': '2.0.1',
    '202': '2.0.2',
    '2.0.2': '2.0.2',
}
